import Component from '@glimmer/component';
import { action } from '@ember/object';
import { guidFor } from '@ember/object/internals';

export default class SlideProdottiComponent extends Component {
  slideId = 'slide-' + guidFor(this);

  @action
  sideScroll(side = 'right') {
    const delta = side === 'right' ? 900 : -900;
    const el = document.getElementById(this.slideId);

    if (el) {
      el.scrollBy({ left: delta, behavior: 'smooth' });
    }
  }
}
